/** Video types the API accepts (apps/api ALLOWED_VIDEO_TYPES). Browsers often leave File.type empty for .mkv and .ts. */
const BY_EXTENSION: Record<string, string> = {
  mp4: "video/mp4",
  m4v: "video/mp4",
  mov: "video/quicktime",
  mkv: "video/x-matroska",
  webm: "video/webm",
  avi: "video/x-msvideo",
  mpg: "video/mpeg",
  mpeg: "video/mpeg",
  ts: "video/mp2t",
  m2ts: "video/mp2t",
};

export const ACCEPTED_TYPES = [...new Set(Object.values(BY_EXTENSION))];
/** For <input type="file" accept>. */
export const ACCEPT_ATTR = [...Object.keys(BY_EXTENSION).map((e) => `.${e}`), ...ACCEPTED_TYPES].join(",");

export function videoContentType(file: { name: string; type: string }): string | null {
  const t = file.type.toLowerCase();
  if (ACCEPTED_TYPES.includes(t)) return t;
  const ext = file.name.toLowerCase().split(".").pop() ?? "";
  return BY_EXTENSION[ext] ?? null;
}
